/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function () {
  // Featured product: mobile image dots synced to swipe carousel
  function initFeaturedProductCarousel(section) {
    if (!section || section.dataset.carouselInit === 'true') return;

    const track = section.querySelector('[data-featured-images]');
    const slides = track ? track.querySelectorAll('[data-featured-image]') : [];
    if (!track || slides.length < 2) return;

    section.dataset.carouselInit = 'true';

    const dots = document.createElement('div');
    dots.className = 'featured-product__dots';
    dots.setAttribute('aria-hidden', 'false');

    slides.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'featured-product__dot' + (index === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Go to image ' + (index + 1));
      dot.addEventListener('click', () => {
        track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
      });
      dots.appendChild(dot);
    });

    const aside = section.querySelector('[data-featured-aside]');
    if (aside) {
      aside.appendChild(dots);
    } else {
      track.parentElement.appendChild(dots);
    }

    const dotButtons = dots.querySelectorAll('.featured-product__dot');

    function setActiveDot(index) {
      dotButtons.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function onScroll() {
      const trackLeft = track.scrollLeft;
      let active = 0;
      let closest = Infinity;

      slides.forEach((slide, index) => {
        const distance = Math.abs(slide.offsetLeft - trackLeft);
        if (distance < closest) {
          closest = distance;
          active = index;
        }
      });

      setActiveDot(active);
    }

    track.addEventListener('scroll', onScroll, { passive: true });
  }

  function initAll() {
    document
      .querySelectorAll('[id*="section_product_3BimXT"] featured-product')
      .forEach(initFeaturedProductCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector
      ? event.target.querySelector('featured-product')
      : null;
    if (section && event.target.id && event.target.id.includes('section_product_3BimXT')) {
      delete section.dataset.carouselInit;
      section.querySelector('.featured-product__dots')?.remove();
      initFeaturedProductCarousel(section);
    }
  });
})();
